import { createContext, type ReactNode, useContext } from 'react'
import { useAuth } from '../hooks/useAuth.ts'

type AuthValue = ReturnType<typeof useAuth>

const Ctx = createContext<AuthValue | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth()
  return <Ctx.Provider value={auth}>{children}</Ctx.Provider>
}

export function useAuthContext(): AuthValue {
  const v = useContext(Ctx)
  if (!v) throw new Error('useAuthContext utanför AuthProvider')
  return v
}
